export default "__VITE_ASSET__b89657a5__"